<template>
  <section class="has-listing-table">
    <div class="level no-margin">
      <div class="level-left bulk-actions" v-if="!isViewOnlyUser">
        <div>
          <span class="navbar-item">
            <a @click.prevent="exportCustomerInfo()" data-cy="pd-bulk-edit"
              >Export</a
            >
          </span>
        </div>
      </div>
      <div class="level-right" v-if="!isViewOnlyUser">
        <div class="level-left current-report-default-view-with-icon">
          <span class="current-report-default-view-text">
            <b-field label="My Customers"></b-field>
          </span>
          <span class="additonal-info">
            <b-tooltip
              label="Shows data of customers where logged in user is added as CAM or Back-up CAM"
              type="is-primary is-light"
              position="is-left"
              multilined
              data-cy="rt-additonal-info"
            >
              <i class="mdi mdi-information" />
            </b-tooltip>
          </span>
        </div>
        <b-switch
          name="default_view"
          :checked="true"
          @input="showCamUserView"
          v-model="showCamUserData"
          class="current-report-default-view-switch"
          data-cy="rt-switch-reports"
        />
      </div>
    </div>

    <circul8-table
      @clickcheck="checkCheckBox"
      @checkedAll="checkedAllData"
      :checkedRows="checkedRow"
      :records="customers"
      :fields="columns"
      :linkEdit="linkEdit"
      :linkView="linkView"
      :enableSwitchAction="enableSwitchAction"
      @switchCustomerView="switchCustomerView"
      :listingComponent="true"
      :whichComponent="whichComponent"
      :isCheckable="true"
      :maxTextLength="'34'"
      :isLoading="isDataLoading"
      @querySet="searchByFilter"
      @backendSort="sortData"
      :backendSortingEnabled="true"
      @loadNextPage="pullNextPage"
      :enableInfiniteScroll="true"
      :hasNextData="nextData"
      :hasPreviousData="previousData"
      @loadPreviousPage="pullPreviousPage"
      :allRRs="userListRR"
    />
    <div class="records-displayed" v-if="totalRecords > 0">
      <span v-if="currentPage * 50 + 50 < totalRecords"
        >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
        {{
          currentPage > 0
            ? nextPageCursor
              ? currentPage * 50 - 50 + customers.length
              : totalRecords
            : customers.length
        }}
        records out of {{ totalRecords }} records</span
      >
      <div v-else>
        <span v-if="currentPage == 0">
          displaying 0 - {{ totalRecords }} records out of
          {{ totalRecords }} records
        </span>
        <span v-else>
          displaying {{ currentPage * 50 - 50 }} - {{ totalRecords }} records
          out of {{ totalRecords }} records
        </span>
      </div>
    </div>
    <b-modal
      :active.sync="isExportCustomerInfoModal"
      :width="600"
      scroll="keep"
      has-modal-card
      data-cy="export-customer-info-modal"
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Export Customer Information</p>
        </header>
        <section class="modal-card-body">
          <b-field
            label="Choose Additional Sheets to Export along with General Information"
          >
            <div class="checkbox-container">
              <b-checkbox
                v-model="formData.selectAll"
                @input="toggleSelectAll"
                data-cy="export-select-all"
              >
                Select All
              </b-checkbox>
              <b-checkbox
                v-model="formData.is_customer_information_sheet"
                native-value="customer_profile"
                data-cy="export-customer-profile"
                @input="updateSelectAll"
              >
                Customer Information
              </b-checkbox>
              <b-checkbox
                v-model="formData.is_scope_sheet"
                native-value="scope"
                data-cy="export-scope"
                @input="updateSelectAll"
              >
                Scope
              </b-checkbox>
              <b-checkbox
                v-model="formData.is_client_credentials_sheet"
                native-value="client_credentials"
                data-cy="export-client-credentials"
                @input="updateSelectAll"
              >
                Client Credentials
              </b-checkbox>
              <b-checkbox
                v-model="formData.is_registration_numbers_sheet"
                native-value="registration_numbers"
                data-cy="export-registration-numbers"
                @input="updateSelectAll"
              >
                Registration Numbers
              </b-checkbox>
              <b-checkbox
                v-model="formData.is_reporting_categories_sheet"
                native-value="reporting_categories"
                data-cy="export-reporting-categories"
                @input="updateSelectAll"
              >
                Reporting Categories
              </b-checkbox>
            </div>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button
            class="button is-primary"
            @click="
              {
                (isExportCustomerInfoModal = false),
                  exportCustomerInfoData(formData);
              }
            "
            data-cy="confirm-export-customer-info"
          >
            Yes, Export
          </button>
          <button
            class="button"
            @click="isExportCustomerInfoModal = false"
            data-cy="cancel-export-customer-info"
          >
            Cancel
          </button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import CustomerProfileDataService from "@/services/CustomerProfileDataService";
import CountryDataService from "@/services/CountryDataService";
import UserDataService from "@/services/UserDataService";
import ContainerDataService from "@/services/ContainerDataService";
import { UserGroup } from "@/services/UserGroups";
import { AuthService } from "@/services/AuthService";
import Circul8Table from "../../components/Circul8Table.vue";
import { Permission } from "../../services/Permissions";
import ScopeMixin from "@/mixins/scopeMixin";
import {
  ExternalUserPermissions,
  ViewOnlyUserPermissions
} from "@/services/PermissionConstant";
// @group Customers
export default {
  name: "CustomersListComponent",
  components: { Circul8Table },
  mixins: [ScopeMixin],
  props: {
    checkable: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selectAll: true,
      checkedData: [],
      checkedRow: [],
      formData: {
        selectAll: false,
        is_customer_information_sheet: false,
        is_scope_sheet: false,
        is_client_credentials_sheet: false,
        is_registration_numbers_sheet: false,
        is_reporting_categories_sheet: false
      },
      map1: new Map(),
      isCheckedAll: false,
      checkedDataMap: new Map(),
      isExportCustomerInfoModal: false,
      query: null,
      showCamUserData: false,
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      switchCustomerId: null,
      totalRecords: 0,
      isLoading: true,
      nextData: false,
      previousData: false,
      currentPage: 0,
      userListCAM: [],
      userListRR: [],
      userListViewOnly: [],
      authService: new AuthService(),
      customerProfileDataService: new CustomerProfileDataService(),
      userDataService: new UserDataService(),
      countryDataService: new CountryDataService(),
      containerDataService: new ContainerDataService(),
      isModalActive: false,
      trashObject: null,
      whichComponent: "CP",
      customers: [],
      isDataLoading: true,
      checkedRows: [],
      countryMap: {},
      countries: [],
      users: [],
      from_dashboard: "",
      linkEdit: "customers.edit",
      linkView: "customers.view",
      linkCustomerSwitch: "home",
      enableSwitchAction: true,
      userMap: {},
      customerIds: [],
      loadCustomerList: true,
      columns: [
        {
          field: "name_short",
          label: "Code",
          searchable: true,
          type: "input",
          visible: true,
          filterKey: { name_short: "" }
        },
        {
          field: "name",
          label: "Customer Name",
          searchable: true,
          type: "input",
          visible: true,
          filterKey: { name: "" }
        },

        {
          field: "countries_of_activities",
          label: "Countries of activities",
          searchable: true,
          type: "input",
          visible: true,
          filterKey: { countries_of_activities: "" }
        },
        {
          field: "reports",
          label: "Reports",
          searchable: true,
          type: "input",
          visible: true,
          filterKey: { reports: "" }
        },
        {
          field: "account_manager",
          label: "Customer Account Manager",
          type: "multiSelectFilter",
          width: "350",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: this.userListCAM,
          filterKey: { account_manager: [] }
        },
        {
          field: "reporting_responsible",
          label: "Reporting Responsible",
          type: "multiSelectFilter",
          width: "350",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: this.userListRR,
          excludeForExternalUser: true,
          filterKey: { reporting_responsible: [] }
        },
        {
          field: "customer_type",
          label: "Customer Type",
          type: "multiSelectFilter",
          width: "350",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: [
            { name: "Small Customer" },
            {
              name: "Small - EuropePlus Customer"
            },
            {
              name: "Small - Flat Rate Customer"
            },
            { name: "Large Customer" }
          ],
          filterKey: { customer_type: [], field_name: "name" }
        },
        {
          field: "operational",
          label: "Operational",
          searchable: true,
          type: "multiSelectFilter",
          visible: true,
          initStatusVals: [],
          allStatusVals: [
            { name: "Yes" },
            {
              name: "No"
            }
          ],
          filterKey: { operational: "", field_name: "name" }
        },
        {
          field: "crm_id",
          label: "CRM ID",
          searchable: true,
          type: "input",
          visible: true,
          filterKey: { crm_id: "" }
        },
        {
          field: "sales_accountable",
          label: "Sales Accountable",
          type: "multiSelectFilter",
          width: "350",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: this.userListViewOnly,
          filterKey: { sales_accountable: [] }
        },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions",
          visible: true,
          searchable: true,
          width: "20",
          type: "actionSearch",
          actionSearch: true,
          filterKey: { actions: "" }
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"]),
    trashObjectName() {
      if (this.trashObject) {
        return this.trashObject.name;
      }

      return null;
    },
    isViewOnlyUser() {
      return this.userGroups.includes(UserGroup.VIEW_ONLY);
    }
  },
  mounted() {
    this.fetchCountries();
    this.fetchUserData();
    this.fetchCustomerData();
  },
  watch: {
    users(newValue) {
      this.assignUserInDropdown(newValue);
    }
  },
  methods: {
    exportCustomerInfoData(formData, selectedCustomers) {
      let checkedRecord = this.checkedData.map(records => records.id);
      if (this.isCheckedAll) {
        checkedRecord = [];
      }
      try {
        this.customerProfileDataService.exportCustomerInfo(
          this.query,
          checkedRecord,
          this.isCheckedAll,
          this.formData
        );
        this.isDataLoading = false;
        this.isDataLoading = false;
        this.isCheckedAll = false;
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
        this.map1 = new Map();
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Download Error !",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    exportCustomerInfo() {
      // Export customer info of selected customers
      const customerIds = this.checkedData.map(customer => customer.id);
      if (customerIds.length === 0) {
        this.$buefy.dialog.alert({
          title: "No Customers Selected",
          message: "Please select at least one customer to export.",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        return;
      } else {
        this.isExportCustomerInfoModal = true;
      }
    },
    toggleSelectAll() {
      const value = this.formData.selectAll;
      this.formData.is_customer_information_sheet = value;
      this.formData.is_scope_sheet = value;
      this.formData.is_client_credentials_sheet = value;
      this.formData.is_registration_numbers_sheet = value;
      this.formData.is_reporting_categories_sheet = value;
    },
    updateSelectAll() {
      this.$nextTick(() => {
        const allSelected =
          this.formData.is_customer_information_sheet &&
          this.formData.is_scope_sheet &&
          this.formData.is_client_credentials_sheet &&
          this.formData.is_registration_numbers_sheet &&
          this.formData.is_reporting_categories_sheet;
        const noneSelected =
          !this.formData.is_customer_information_sheet &&
          !this.formData.is_scope_sheet &&
          !this.formData.is_client_credentials_sheet &&
          !this.formData.is_registration_numbers_sheet &&
          !this.formData.is_reporting_categories_sheet;

        if (allSelected) {
          this.formData.selectAll = true;
        } else if (noneSelected) {
          this.formData.selectAll = false;
        }
        // If partially selected, selectAll remains unchanged
      });
    },

    checkCheckBox(d) {
      // select all should be false now
      const total_checked = this.checkedData.length;
      const indexes = [];
      //getting the index of the checked rows
      d.forEach(element => {
        const index = this.customers.findIndex(object => {
          return element.id === object.id;
        });
        indexes.push(index);
      });
      // create 2 dictionary. one with indexes for showing current page selected another with checked row value
      this.map1.set(this.currentPage, indexes);

      if (d.length > 0) {
        this.checkedDataMap.set(this.currentPage, d);
      } else {
        !this.isCheckedAll && this.checkedDataMap.set(this.currentPage, d);
      }
      this.checkedRow = d;
      this.checkedData = [];
      // converting mapped data into array for bulk operations
      this.checkedDataMap.forEach(element => {
        this.checkedData.push(...element);
      });
      // if checked all is true and deselect any
      if (this.isCheckedAll && total_checked > this.checkedData.length) {
        this.isCheckedAll = false;
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
        this.map1 = new Map();
      }
    },
    checkedAllData(value) {
      this.isCheckedAll = value;
      if (!this.isCheckedAll) {
        this.checkedRow = [];
        this.map1 = new Map();
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
      } else {
        this.checkedDataMap.set(this.currentPage, this.customers);
      }
    },
    showCamUserView() {
      this.customers = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      // check includes and replace
      this.query = this.query
        ? this.query.replace(/cam_user=[^&]*&?/g, "").replace(/&$/, "")
        : "";
      this.query = this.query + "&cam_user=" + this.showCamUserData;

      if (this.query.includes("page=")) {
        // replace pagination page parameter from query string
        this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      }
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.PreviousPageCursor = null;
      this.displayedRecords = 0;
      this.currentPage = 0;
      this.nextData = false;
      this.fetchCustomerData(this.query);
    },
    pullNextPage() {
      if (this.loadCustomerList) {
        this.previousData = true;
        this.loadMoreClicked = true;
        this.currentPage = this.currentPage + 1;
        const temp = this.nextPageCursor.split("?")[1].split("&");
        const query_part = temp.filter(function(value) {
          return value.indexOf("page=") == -1;
        });
        if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
          this.query =
            query_part.join("&") + "&page=" + (this.currentPage + 1) + "&";
          setTimeout(() => {
            this.isDataLoading = true;
            this.fetchCustomerData(this.query, "next");
          }, 300);
        }
      }
    },
    pullPreviousPage() {
      if (this.loadCustomerList) {
        this.nextData = true;
        this.loadMoreClicked = true;
        const temp = this.PreviousPageCursor.split("?")[1].split("&");
        const query_part = temp.filter(function(value) {
          return value.indexOf("page=") == -1;
        });
        if (this.currentPage == 0 || this.currentPage == 1) {
          this.query = "&" + query_part.join("&") + "&page=1&";
          this.previousData = false;
        } else {
          this.query =
            "&" + query_part.join("&") + "&page=" + this.currentPage + "&";
        }
        this.currentPage =
          this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
        setTimeout(() => {
          this.isDataLoading = true;
          this.fetchCustomerData(this.query, "prev");
        }, 300);
      }
    },
    searchByFilter(filterQuery) {
      if (this.loadCustomerList) {
        this.nextPageCursor = null;
        this.currentPage = 0;
        this.customers = [];
        this.nextData = false;
        this.map1 = new Map();
        this.checkedRow = [];
        this.isCheckedAll = false;
        this.checkedData = [];
        this.checkedDataMap = new Map();
        // Add cam_user parameter
        filterQuery += "cam_user" + "=" + this.showCamUserData + "&";
        this.query = filterQuery;

        // Clean query from any existing sort parameters
        if (this.query.includes("order_field=")) {
          this.query = this.query
            .replace(/&order_field=[^&]*&?/g, "&")
            .replace(/&&/g, "&");
        }
        if (this.query.includes("order_by=")) {
          this.query = this.query
            .replace(/&order_by=[^&]*&?/g, "&")
            .replace(/&&/g, "&");
        }

        // Add sort parameters if they exist
        let query = this.query;
        if (this.lastSortColumn) {
          query =
            this.query +
            "&order_field=" +
            this.lastSortColumn +
            "&order_by=" +
            this.lastSortOrder;
        }

        setTimeout(() => {
          this.isDataLoading = true;
          this.fetchCustomerData(query);
        }, 300);
      }
    },
    sortData(field, order) {
      if (this.loadCustomerList) {
        this.loadMoreClicked = false;
        this.nextPageCursor = null;
        this.currentPage = 0;
        this.customers = [];
        this.nextData = false;
        this.map1 = new Map();
        this.checkedRow = [];
        this.isCheckedAll = false;
        this.checkedData = [];
        this.checkedDataMap = new Map();

        // Create a clean query by removing pagination, sorting and cam_user parameters
        let cleanQuery = this.query || "";

        // Remove page parameter (pagination)
        cleanQuery = cleanQuery.replace(/page=[0-9.]{1,2}&/g, "");

        // Remove cam_user parameter
        cleanQuery = cleanQuery
          .replace(/cam_user=[^&]*&?/g, "")
          .replace(/&$/, "");

        // Remove order_field parameter
        cleanQuery = cleanQuery.replace(/order_field=[^&]*&?/g, "");

        // Remove order_by parameter
        cleanQuery = cleanQuery.replace(/order_by=[^&]*&?/g, "");

        // Clean up any double ampersands
        cleanQuery = cleanQuery.replace(/&&/g, "&");

        // Ensure we have an ampersand at the start if needed
        if (cleanQuery && !cleanQuery.startsWith("&")) {
          cleanQuery = "&" + cleanQuery;
        }

        // Add back the cam_user parameter
        cleanQuery +=
          (cleanQuery ? "&" : "") + "cam_user=" + this.showCamUserData;

        // Add the new sort parameters
        cleanQuery += "&order_field=" + field + "&order_by=" + order;

        // Update the query
        this.query = cleanQuery;
        this.lastSortColumn = field;
        this.lastSortOrder = order;

        setTimeout(() => {
          this.isDataLoading = true;
          this.fetchCustomerData(this.query);
        }, 300);
      }
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      // Extract parameter name (key) from the param string
      const getParamName = paramStr => {
        const matches = paramStr.match(/&([^=]+)=/);
        return matches ? matches[1] : null;
      };

      const paramName = getParamName(newParam);

      if (paramName) {
        // Remove all instances of the parameter using regex
        const regex = new RegExp(`&${paramName}=[^&]*`, "g");
        this.query = this.query.replace(regex, "");
      }

      // Add the new parameter
      this.query += newParam;

      return this.query;
    },
    isEditAllowed(data) {
      if (this.userGroups.includes(UserGroup.VIEW_ONLY)) {
        return false;
      } else if (
        this.userGroups.includes(UserGroup.EPR_ADMIN) ||
        (this.userHasPermission(Permission.CUSTOMER_PROFILE_CHANGE_CAM) &&
          (data.account_manager_id == this.userId ||
            data.backup_account_manager == this.userId))
      ) {
        return true;
      } else {
        return false;
      }
    },
    /** TODO: Give self-explanatory name, e.g. createLookupMap */
    prepareMasterData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["name"];
      }
      return resultDict;
    },
    assignUserInDropdown(users) {
      this.userListRR = this.filterUsers(users, "Reporting Responsible");
      const rrIndex = this.find_column_index("reporting_responsible");
      if (rrIndex > -1) {
        this.columns[rrIndex].allStatusVals = this.userListRR;
      }

      this.userListCAM = this.filterUsers(users, "Customer Account Manager");
      const camIndex = this.find_column_index("account_manager");
      if (camIndex > -1) {
        this.columns[camIndex].allStatusVals = this.userListCAM;
      }

      this.userListViewOnly = this.filterUsers(users, "View Only");
      const ViewOnlyIndex = this.find_column_index("sales_accountable");
      if (camIndex > -1) {
        this.columns[ViewOnlyIndex].allStatusVals = this.userListViewOnly;
      }
      if (this.customers && this.customers.length > 0) {
        for (const idx in this.customers) {
          const customer = this.customers[idx];
          customer["account_manager"] = this.userMap[
            customer["account_manager"]
          ];
          customer["reporting_responsible"] = this.userMap[
            customer["reporting_responsible"]
          ];

          customer["sales_accountable"] = this.userMap[
            customer["sales_accountable"]
          ];
        }
      }
    },
    filterUsers(users, role) {
      const newUsers = [];
      for (const user of users) {
        const epradmin = user.groups.filter(e => e.name === role);
        if (epradmin.length > 0) {
          newUsers.push(user);
        }
      }
      return newUsers;
    },
    fetchCustomerData(search = "", scrollDir) {
      this.loadCustomerList = false;
      this.customerProfileDataService.getAll(search).subscribe(response => {
        this.loadCustomerList = true;
        this.PreviousPageCursor = this.nextPageCursor
          ? this.nextPageCursor
          : this.PreviousPageCursor;
        this.nextPageCursor = response["next"];
        if (this.currentPage > 1) {
          this.previousData = true;
          if (this.nextPageCursor != null) {
            this.nextData = true;
          } else {
            this.nextData = false;
          }
        } else {
          this.previousData = false;
          if (this.nextPageCursor != null) {
            this.nextData = true;
          } else {
            this.nextData = false;
          }
        }
        this.totalRecords = response["count"];
        let tempData = [];
        if (scrollDir == "next") {
          if (!this.nextPageCursor) {
            this.prepareData(response["results"]);
          } else {
            tempData = [...this.customers, ...response["results"]];
            if (tempData.length > 100 && this.nextPageCursor != null) {
              tempData = tempData.slice(50, 150);
            }
            this.prepareData(tempData);
          }
        } else if (scrollDir == "prev") {
          //this.totalRecords = this.data.length + response["count"];
          if (this.currentPage == 0) {
            this.prepareData(response["results"]);
          } else {
            tempData = [...response["results"], ...this.customers];
            if (tempData.length >= 100) {
              tempData = tempData.slice(0, 100);
            }
            this.prepareData(tempData);
          }
        } else {
          this.prepareData(response["results"], scrollDir);
        }
        //this.prepareData(response["results"]);
        this.isDataLoading = false;
      }, this.handleApiError);
    },
    /**
     * TODO: Method unnecessary as [string1, string2].filter(s => s.length).join(separator) does the same.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/join
     */
    joinStrings(string1, string2, separator) {
      return string1 + (string1 === "" ? "" : separator) + string2;
    },

    /**
     * TODO: #1 Give self-explanatory name, e.g. createLookupMap
     *
     * TODO: #2 Why wouldn't we retrieve this data directly from API? There it could be cached, come from search index, ...
     */
    prepareData(data) {
      const dataList = [];
      for (const idx in data) {
        const customer = data[idx];
        if (customer["parent_customer"] == null) {
          customer["countries_of_activities"] = customer["scope"];
        } else {
          customer["countries_of_activities"] = customer["country"];
        }
        customer["account_manager_id"] = customer["account_manager"];
        customer["reporting_responsible_id"] =
          customer["reporting_responsible"];
        customer["sales_accountable_id"] = customer["sales_accountable"];
        if (this.userMap[customer["account_manager"]]) {
          customer["account_manager"] = this.userMap[
            customer["account_manager"]
          ];
        }
        if (this.userMap[customer["reporting_responsible"]]) {
          customer["reporting_responsible"] = this.userMap[
            customer["reporting_responsible"]
          ];
        }

        customer["actions"] = this.isEditAllowed(customer);
        if (
          customer["operational"] == "NA" ||
          customer["operational"] == "No"
        ) {
          customer["active"] = false;
        } else {
          customer["active"] = true;
        }
        if (this.userMap[customer["sales_accountable"]]) {
          customer["sales_accountable"] = this.userMap[
            customer["sales_accountable"]
          ];
        }

        dataList.push(customer);
      }

      let updateddataList = [];
      if (this.$route.params.from_dashboard !== undefined) {
        const filteredCust = this.$route.params.from_dashboard.split(",");

        for (const cust of dataList) {
          if (filteredCust.includes(cust.id.toString())) {
            updateddataList.push(cust);
          }
        }
      } else {
        updateddataList = dataList;
      }

      if (this.nextPageCursor == null) {
        this.customers.push(...updateddataList);
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        this.customers = updateddataList;
      }
    },
    switchCustomerView(row) {
      /**
       * This function set the switch customer global variables and redirects to dashboard
       */

      this.$buefy.dialog.confirm({
        message: `Do you really want to switch to Customer ${row.name} View ?`,
        onConfirm: () => {
          const switchCustomerData = {
            isSwitchCustomerView: true,
            switchCustomerNumber: row.id,
            switchCustomerName: row.name,
            timestamp: Date.now() // Add timestamp to make each change unique
          };

          // Store the time of the switch for tabs to check against
          localStorage.setItem("lastSwitchCustomerTime", Date.now().toString());

          this.$store.commit("customer", switchCustomerData);
          localStorage.setItem(
            "switchCustomerView",
            JSON.stringify(switchCustomerData)
          );

          let switchCustomerPermission = null;
          let switchCustomerGroup = null;
          if (this.userGroups.includes(UserGroup.VIEW_ONLY)) {
            switchCustomerPermission = ViewOnlyUserPermissions;
            switchCustomerGroup = [UserGroup.VIEW_ONLY];
          } else {
            switchCustomerPermission = ExternalUserPermissions;
            switchCustomerGroup = [UserGroup.EXTERNAL_USER];
          }

          this.$store.commit("user", {
            groups: switchCustomerGroup,
            permissions: switchCustomerPermission,
            isExternal: true
          });

          this.$router.push({
            name: this.linkCustomerSwitch,
            params: { id: row.id, row: row }
          });
          window.location.reload();
        }
      });
    },

    trashModal(trashObject) {
      this.trashObject = trashObject;
      this.isModalActive = true;
    },
    trashConfirm() {
      this.isModalActive = false;
      this.$buefy.snackbar.open({
        message: "Confirmed",
        queue: false
      });
    },
    trashCancel() {
      this.isModalActive = false;
    },
    handleApiError(reason) {
      let errorMessage = reason.response.data["detail"];

      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Invalid input";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
      //this.fetchCustomerData();
      this.isDataLoading = false;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.checkbox-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.checkbox-separator {
  margin: 0.5rem 0;
  border: none;
  border-top: 1px solid #dbdbdb;
}
</style>
